import { z } from 'zod';
import { defineEndpoint } from '../define';

/** Issues a new agent token (shown once) and invalidates the old one immediately. */
export const rotateRunnerMachineToken = defineEndpoint({
  method: 'POST',
  path: '/v1/runner-monitor/machines/:machineId/token',
  params: z.object({ machineId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.object({ token: z.string() }) }),
});
